import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/tw` 本身沒有畫面，它導向市場首頁。
 *
 * 市場首頁是 `/dashboard`——§10.5 那一頁就是「使用者每天早上真正會打開的那一頁」，
 * 而市場首頁應該落在那裡。
 */
export const Route = createFileRoute('/$market/')({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$market/dashboard',
      params: { market: params.market },
      search,
      replace: true,
    });
  },
});
